import { ApplicantType } from "shared/types/application";

import { FormData } from "../types";
import { BellRinging03, Building05, Toggle01Left } from "untitledui-js-base";
import { getFullName } from "shared/utils/get-full-name";
import { Applicant } from "types/application";

export const SuccessView = ({
  formData,
  address,
  applicants
}: {
  formData: FormData;
  address: string;
  applicants: Applicant[];
}) => {
  return (
    <div className="p-6 bg-background-900 min-h-full">
      {formData.unlistUnit ? (
        <div className="bg-white mb-4 rounded-lg border border-alpha-100 shadow-xs">
          <div className="p-6 pb-4 border-b border-alpha-40">
            <div className="flex items-center gap-4">
              <Toggle01Left className="h-8 w-8 stroke-content-200 shrink-0" />
              <p className="text-base font-medium text-content-1000">
                Unit unlisted
              </p>
            </div>
          </div>
          <p className="p-6 text-sm font-medium text-content-1000">
            Acceptance of new applications for {address}, has been paused{" "}
          </p>
        </div>
      ) : null}

      {formData.sendNotifications ? (
        <div className="bg-white mb-4 rounded-lg border border-alpha-100 shadow-xs">
          <div className="p-6 pb-4 border-b border-alpha-40">
            <div className="flex items-center gap-4">
              <BellRinging03 className="h-8 w-8 stroke-content-200 shrink-0" />
              <p className="text-base font-medium text-content-1000">
                Emails about decision have been sent
              </p>
            </div>
          </div>
          <ul className="p-6">
            {applicants.map((applicant) => (
              <li
                key={applicant.id}
                className="text-sm font-medium mb-4 text-content-1000"
              >
                {getFullName({
                  firstName: applicant.first_name,
                  lastName: applicant.last_name,
                  middleName: applicant.middle_name,
                  short: true
                })}
                ,{" "}
                <span className="text-content-200">
                  {applicant.role === ApplicantType.CoSigner
                    ? "Guarantor"
                    : "Applicant"}
                </span>
              </li>
            ))}
          </ul>
        </div>
      ) : null}

      {formData.addApplicantsToPMS ? (
        <div className="bg-white mb-4 rounded-lg border border-alpha-100 shadow-xs">
          <div className="p-6">
            <div className="flex items-center gap-4">
              <Building05 className="h-8 w-8 stroke-content-200 shrink-0" />
              <p className="text-base font-medium text-content-1000">
                Prospects have been created in your Property Management Software{" "}
              </p>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};
